<template>
  <bvue-ui-view class="">
    <bvue-ui-overlay :active="loading" color="#FFFFBF">
      <app-lottie :options="lottieOptions" :height="300" :width="300" />
    </bvue-ui-overlay>
    <bvue-ui-panel :aside-width="296" :breakpoint="900" :modals-container="true" header-class="">
      <div slot="toggler" class="ml-1">
        <img :src="require('@/assets/images/menu.svg')"/>
      </div>
      <header slot="header" class="flx header">
        <div class="flex-1 ml-3 cursor-pointer" @click="$router.push('/'); reloadMap()">   
            <img class="logomain menuresponsive" :src="require('@/assets/images/plantavida.png')"/>
        </div>
        <div class="flex justify-center">
          <lenguaje></lenguaje>
        </div>
      </header>
      <aside slot="aside">
        <aside-menu></aside-menu>
      </aside>
      <bvue-ui-router-view :key="$route.fullPath"></bvue-ui-router-view>
    </bvue-ui-panel>
    <transition name="fade">
      <session-page v-if="showSession"></session-page>
    </transition>
  </bvue-ui-view>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import AppLottie from 'vue-lottie'
import * as animationData from '@/assets/lottie.json'
import AsideMenu from '@/components/aside/AsideMenu'
import SessionPage from '@/pages/Session'
import { i18n } from '@/plugins/i18n'
import Lenguaje from '@/components/Lenguaje'


export default {
  name: 'App',
  components: {
    AsideMenu,
    AppLottie,
    SessionPage,
    Lenguaje
  },
  computed: {
    ...mapState('auth', ['loading', 'showSession'])
  },
  data () {
    return {
      showBack: false,
      menuPaths:['/', '/profile', '/species', '/ranking', '/about','/about_us', '/admin/countries', '/admin/species', '/admin/ecosystems', '/admin/reserves','/admin/seriales'],
      lottieOptions: {
        animationData: animationData
      }
    }
  },
  methods: {
    isMobile: () => {
      return isMobile() ? 'true' : 'false'
    },
    reloadMap () {
      this.$store.commit('bigMap')
      this.$store.commit('recargarMapa')
      this.$store.commit('reservaActiva', null) 
    }
  },
  created () {
    this.$store.dispatch('initialize')
    this.showBack = !this.menuPaths.includes(this.$route.path)
  },
  watch: {
     '$route' (to, from) {
       console.log('to.name: ', to.name)
       console.log('from.name: ', from.name)
       this.showBack = !this.menuPaths.includes(to.path)
     }
  }
}
</script>

<style lang="scss" src="./style/main.scss"></style>




// WEBPACK FOOTER //
// src/App.vue